import _ from 'lodash';
import moment from 'moment';
import { t } from '../../../components/common/Translate';
import { datesFormat } from '../../../config';
import { Auth } from '../../../config/configuration/react';

const getTitle = (vehicle) => `${vehicle.brandLabel} - ${vehicle.modelLabel} - ${vehicle.type} 
  - ${vehicle.fuelLabel} - ${vehicle.gearboxLabel} - ${vehicle.engine}CV - ${vehicle.cylinderCapacity}cm3 
  - ${vehicle.door} - ${t('doors')} - ${vehicle.seat} - ${t('seats')} - ${vehicle.color}`;

const formatDate = (date) => {
  const lang = Auth.preferredLanguage();
  return moment(date).format(
    lang.toUpperCase() === 'DE' ? _.toUpper(datesFormat[lang.toUpperCase()]) : _.toUpper(datesFormat.default),
  );
};

const isFirstHand = (firstHand) => (firstHand === true ? '1ere MAIN' : '2eme MAIN ou +');

export const vehiclePresenter = (vehicle) => {
  if (vehicle) {
    _.set(vehicle, 'title', getTitle(vehicle));
    _.set(vehicle, 'grayCardDateFormated', formatDate(vehicle.grayCardDate));
    _.set(vehicle, 'releaseDateFormated', formatDate(vehicle.releaseDate));
    _.set(vehicle, 'productionDateFormated', formatDate(vehicle.productionDate));
    _.set(vehicle, 'Owner', isFirstHand(vehicle.firstHand));
    return vehicle;
  }
  return null;
};
